import { User } from '@synergetx/puppet-interview-types';
import { getSingleObject, onSingleItemUpdate } from './firestore-utils';

const USERS = 'Users';

export const getUser = async (userId: string): Promise<User | false> =>
    getSingleObject<User>(`${USERS}/${userId}`, 'getUser', false);

export const onUserUpdate = (userId: string, onUpdate: (user: User | null) => void) =>
    onSingleItemUpdate<User>(userId, USERS, onUpdate, 'onUserUpdate');
